import script from "./MarkdownContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarkdownContent.vue?vue&type=script&setup=true&lang=ts"

import "./MarkdownContent.vue?vue&type=style&index=0&id=0b800994&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b800994"]])

export default __exports__